import Axios from "axios";
import FileDownload from 'js-file-download';
import ApiClient, { createFetchErrorMessage } from "../../../utils/api/ApiClient";
import { createSlice } from "@reduxjs/toolkit";


const initialState = {
	loading:true, result:false, book:null, message:null, wishBook:null, workBooks:null, 
	topicClosed:true,
	bannerList:[], cardList:null, 
	activityCount:{ bookReportCount:0, debateCount:0, quizCount:0, readingPhotoCount:0, 
									readingPictureCount:0, youtubeCount:0 }
	};

const detailBookSlice = createSlice({
	name: 'detailBook',
	initialState,
	reducers: {
		loading: (state) => {
			state.loading = true;
		},
		fetch: (state, action) => {
			// state.loading = false;
			// state.result = true;
			return {...state, ...action.payload, loading:false, result:true}
			// state.book = action.payload.book;
			
			// state.appleCheck = action.payload.appleCheck;
			// state.activityCount = action.payload.activityCount;
			
			// state.bannerList = action.payload.bannerList;
			// state.cardList = action.payload.cardList;
			// state.relatedBooks = action.payload.relatedBooks;
			// state.relatedPublisherBooks = action.payload.relatedPublisherBooks;
			// state.wishBook = action.payload.wishBook;
			// state.workBooks = action.payload.workBooks;
		},
		error: (state, action) => {
			state.notice = null;
			state.loading = false;
			state.message = action.payload.message;
		},
		toggle: (state, action) => {
			state.wishBook = action.payload;
		}
	}
});

export default detailBookSlice.reducer;
export const detailBookActions = detailBookSlice.actions;

let bookDetailCancel;
export function fetchBookDetail (isbn) {
    return function (dispatch) {
		dispatch( detailBookActions.loading() );
		
		if (bookDetailCancel!==undefined) bookDetailCancel();
		const { promise, cancel } = ApiClient({
			url:`/api/book/${isbn}`,
			data:{school_code: window.schoolCode},
			authToken:sessionStorage.getItem('user')
		});
		
		bookDetailCancel = cancel;
		promise.then(res=>{
			if(res===undefined) return;
			dispatch( detailBookActions.fetch(res.data) );
		}).catch( err=>{
			const errData = createFetchErrorMessage(err, '도서를 가져오지 못했습니다.');
      dispatch( detailBookActions.error(errData.message) );
		});
    }// return
}//end fetchBookDetail

export function toggleWishBook (isbn) {
    return function (dispatch) {

			const { promise } = ApiClient({
				method:'get',
				url:`/api/book/keep/toggle/${isbn}`,
				authToken:sessionStorage.getItem('user')
			});
			
			promise.then(res=>{
				dispatch( detailBookActions.toggle(res.data) );
			}).catch( (err)=>{
				console.log(err)
			});
    }// return
}// toggleWishBook


/**
 * 독서활동지 다운로드
 * @param {*} workbook 
 */
export function downloadWorkbook (workbook) {
	return function (dispatch) {

		const { promise } = ApiClient({
			url:`/api/workbook/${workbook.id}/download`,
			authToken:sessionStorage.getItem('user')
		});
		
		promise.then(res=>{
			const resultData = res.data;
			const downloadUrl = resultData.download;
			Axios.get(downloadUrl,{
					responseType:'blob'
				}).then(fileRes=>{
					FileDownload(fileRes.data, resultData.filename);
				}).catch( (exRes=>{
					console.log("#error catch")
					console.log(exRes);
				}));
		}).catch( (err)=>{
			console.log(err)
		});
    }// return
}//end download
